<template lang="pug">
div
  b-form-row.align-items-center.mb-3
    b-col(cols="auto")
      Avatar.mr-3(size="xs", :src="userData.profile_pic", :platform="conversation.platform")
    b-col
      span {{ userName.trim() || 'Usuario' }}
  h5.text-center.mb-2 Historial de órdenes
  b-card.mb-0(no-body)
    //template(slot="header")
      b-input-group
        b-form-input(placeholder="Buscar orden", type="search", v-model="search_text")
        b-input-group-append
          b-button(variant="soft-secondary")
            .d-flex.align-items-center
              b-spinner(small, v-if="loading", variant="primary")
              search-icon.icon-sm(v-else)
              span.ml-2(v-if="$breakpoint.mdUp") Buscar
    b-table(ref="orders_table", :fields="order_fields", :items="orders", striped, responsive, show-empty, :busy="loading", hover, @row-clicked="getOrder")
      template(v-slot:empty)
        span.text-secondary {{search_text.length ? "No hay conincidencias" : "El usuario no tiene ordenes registradas"}}
      template(v-slot:table-busy)
        .text-center
          b-spinner(variant="primary")
      template(v-slot:cell(order_id)="{ item }")
        .d-flex.align-items-center.text-secondary.text-left
          div(style="flex: 1;")
            div
              span.font-weight-bold Orden:
              span.ml-2 {{ item.reference }}
            div(v-if="item.delivery_type == 'kanguro'")
              span.font-weight-bold Guía de rastreo:
              span.ml-2 {{ item.track_id }}
            .text-sm
              span.font-weight-bold Fecha:
              span.ml-2 {{ $moment(item.updatedAt).format("DD MMMM YYYY, HH:mm [hrs]") }}

            //b-button(size="sm" variant="primary" :to="{name: 'Orders', query: {order_id: item.order_id} }" target="_blank") Ver orden
              arrow-right-icon.icon-sm.ml-2
          chevron-right-icon.text-help
    .d-flex.align-items-center(v-if="orders.length")
      b-pagination.mb-0(:total-rows="ordersCount", :per-page="ordersLimit", :value="ordersPage", @change="ordersPage = $event;getOrders();")
    //.text-center.mt-4
      b-link(@click="orders_modal = true") Ver historial de órdenes

    SideModal(v-model="order_modal" padding)
      template
        b-form-row.mb-3
          b-col
            h5.text-center.mb-0 Orden de Compra
          //- b-col(cols="auto")
          //-   b-button(variant="primary" size="sm") Enviar recibo

        b-list-group.mb-3
          b-list-group-item
            div.mb-3
              span.font-weight-bold Orden:
              span.ml-2 {{ order.reference }}
            b-form-row.mb-3
              b-col
                div
                  span.font-weight-bold Estatus:
                  span.mb-0.ml-2(:class="`text-${order_status.color}`") {{ order_status.title }}
                    check-circle-icon.icon-sm.ml-2.text-success(v-if="order.status === 'paid'")
              //b-col.text-right
                b-link.text-sm(@click="status_modal = true;") Cambiar status
            div
              span.font-weight-bold Fecha:
              span.ml-2 {{ $moment(order.updatedAt).format("DD MMMM YYYY, HH:mm [hrs]") }}

          b-list-group-item
            b-form-row.mb-3
              b-col
                p.mb-0.font-weight-bold Tipo de envío:
                p.mb-0(v-if="order.delivery_type") {{ order.delivery_type }}
                p.mb-0.text-secondary(v-else) No seleccionado
              //b-col.text-right
                b-link.text-sm(@click="delivery_modal = true;") Configurar envío

            div.mb-3(v-if="order.delivery_type == 'kanguro'")
              p.mb-0.font-weight-bold Guía de rastreo:
              p.mb-0 {{ order.track_id }}

            div
              p.mb-0.font-weight-bold Dirección de entrega:
              p.mb-0(v-if="order.delivery_address") {{ order.delivery_address }}
              p.mb-0.text-secondary(v-else) Aún no proporcionada

        b-list-group.mb-3
          b-list-group-item.bg-light
            .d-flex.align-items-center.justify-content-between
              span.font-weight-bold Pedido
              //b-link.text-sm(@click='getPaymentUrl') Enviar liga de pago

          b-list-group-item
            p.mb-0.text-secondary(v-if="!order_summary.length") No se han agregado productos a la orden
            b-form-row.product-row(v-for="(item, index) in order_summary" :key="index")
              b-col(cols="auto")
                b-img(width="60" height="60" rounded :src="item.image" :blank="!item.image" blank-color="#f2f2f2" style="object-fit:cover;")
              b-col
                b-form-row
                  b-col
                    p.font-weight-bold.mb-0 {{ item.product }}
                  b-col(cols="auto")
                    p.font-weight-bold.mb-0 {{ item.price }}
                  b-col(cols="12")
                    ul(v-if="item.variants && item.variants.length")
                      li.text-secondary(v-for="item_v in item.variants" :key="item_v") {{item_v}}
                    .d-flex.align-items-center.justify-content-between
                      p.mb-0.text-secondary {{ item.quantity }} unidades
                      //b-link.text-danger.text-sm(@click="removeProduct(item)") Quitar
          b-list-group-item
            b-form-row.mb-2
              b-col
                span Subtotal:
              b-col(cols="auto")
                span {{ order.total || 0 }}

            b-form-row.mb-2
              b-col
                span Envío:
              b-col(cols="auto")
                span {{ order.delivery_price || 0 }}

            b-form-row.mb-2
              b-col
                span Descuento:
              b-col(cols="auto")
                span {{ order.discount || 0 }} %

            b-form-row.font-weight-bold
              b-col
                span Total:
              b-col(cols="auto")
                span {{ order.total_final || 0 }}
</template>

<script>
import Avatar from './Avatar.vue'
import orderStatus from '@/data/orderStatus'

import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      orderStatus: orderStatus,
      orders: [],
      order_summary: [],
      current_order: {},
      order: {},
      loading_order: false,
      notify_checkbox: true,
      loading: false,
      search_text: "",
      order_fields: [
        {
          key: "order_id",
          thStyle: {
            display: 'none'
          }
        },
      ],
      order_modal: false,
      ordersPage: 1,
      ordersCount: 0,
      ordersLimit: 10
    }
  },
  props: {
    conversationId: {
      type: String,
      default: ''
    },
    conversation: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account,
    }),
    userData () {
      return (this.conversation && this.conversation.user) ? this.conversation.user : {}
    },
    userName () {
      return Object.keys(this.userData).length ? `${this.userData.first_name || ''} ${this.userData.last_name || ''}` : ''
    },
    order_status () {
      let self = this
      let status = this.orderStatus.find(s => s.name == self.order.status)
      if (status) {
        return status
      }
      return {
        name: self.order.status,
        title: self.order.status,
        color: 'secondary',
      }
    },
  },
  methods: {
    ...mapActions(['order/all', 'order/get', 'order/getByConversation']),
    getOrders () {
      let self = this
      this.loading = true

      let pagination = {page: this.ordersPage, limit: this.ordersLimit}

      this['order/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...pagination,
          platform: 'all',
          status: null,
          user: this.conversation.user_id
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.orders = res.resource
            this.ordersCount = res.total
          }
        }
      })
    },
    getCurrentOrder () {
      if(!this.conversationId) return
      let self = this
      this.loading_order = true

      this['order/getByConversation']({
        params: {
          conversation_id: this.conversationId
        },
        callback: res => {
          self.loading_order = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.current_order = Object.assign(self.current_order, res.resource)
          }
        }
      })
    },
    getOrder (row) {
      let self = this
      this.loading_order = true

      this['order/get']({
        ...row,
        callback: res => {
          self.loading_order = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.order = Object.assign({}, res.resource)
            self.order_summary = resource.summary ? resource.summary.slice() : ""
            let formater = new Intl.NumberFormat("es-MX", {style: "currency", currency: self.order.currency || "MXN"});
            self.order.total = formater.format(self.order.total)
            self.order.delivery_price = formater.format(self.order.delivery_price)
            self.order.total_final = formater.format(self.order.total_final)
            self.$nextTick(() => {
              self.order_modal = true
            })
          }
        }
      })
    },
    updateOrder (data, silent = false) {
      var self = this

      this['order/update']({
        order_id: self.order.order_id,
        account_id: self.$route.params.account_id,
        ...data,
        callback: res => {
          if (res.error) {
            if (!silent)
              self.$message.error(res.error)
          } else {
            if (!silent)
              self.$message.success('Orden actualizada')
            self.getOrder(self.order.order_id)
          }
        }
      })
    },
    updateOrderStatus (status, confirmed = false) {
      if (status.name == 'pay_on_delivery' && !confirmed) {
        this.confirmPaymentAgaintsDelivery()
        return
      }
      var self = this

      let json_data = {
        status: status.name,
        notify: self.notify_checkbox,
        order_id: self.order.order_id,
        account_id: self.$route.params.account_id,
      };

      this['order/updateStatus']({
        ...json_data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden actualizada')
            self.getOrder(self.order.order_id)
            this.status_modal = false
          }
        }
      })
    },
    cancelOrder () {
      let self = this

      this['order/cancel']({
        order_id: self.order.order_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden cancelada')
            self.getOrder(self.order.order_id)
          }
        }
      })
    },
  },
  components: {
    Avatar
  },
  mounted () {
    this.getOrders()
    //this.getCurrentOrder()
  }
}
</script>

<style>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>

<style lang="scss" scoped>
  .product-row {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .rotate-animation {
    animation-name: rotateAnimation;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
</style>